export const HOME_PAGE = '/';
export const ORDER_PAGE = '/order';
export const RESULT_PAGE = '/result';
